// extracted by mini-css-extract-plugin
export default {"bxp-intro-container":"Intro_bxp-intro-container__wryDE","fadeOut":"Intro_fadeOut__cTARu","slideLeft":"Intro_slideLeft__yl8lG","slideRight":"Intro_slideRight__DDCsi"};